import React from "react";
import Slider from "react-slick";

function Carousel({ images }) {
  const images_list = []
  images.map((image) => {
    images_list.push(image.url)
  });

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    variableHeight: false
  };
  return (
    <div>
      <Slider {...settings}>
        {images_list.map((src) => (
          <div className="bg-dark" key={src}>
            <img className="m-auto max-h" src={src} alt='image' />
          </div>
        ))}
      </Slider>
    </div>
  );
}
export default Carousel;
